<template>
  <div class="no-tabs sent-geo-modal">
    <button
      v-if="filterButton"
      class="btn btn-primary btn-sm"
      @click="resetFilters"
      style="margin-bottom: -50px;z-index: 2;position: relative"
    >
      {{ t('modules.forms.list.deleteFilters') }}
    </button>
    <DxDataGrid
      :ref="dataGridRef"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :column-hiding-enabled="true"
      :data-source="store"
      :hover-state-enabled="true"
      :remote-operations="remoteOperations"
      :show-borders="true"
      :show-column-lines="true"
      class="dx-selection-disabled"
      @optionChanged="checkFilters"
    >
      <DxHeaderFilter :visible="true" />
      <DxPaging
        :page-index="0"
        :page-size="20"
      />
      <DxPager
        :show-info="true"
        :show-navigation-buttons="true"
        :visible="true"
      />
      <DxFilterRow :visible="true" />
      <DxColumnFixing :enabled="true" />
      <DxSearchPanel
        :visible="true"
        :width="240"
        :placeholder="$t('components.sentGeo.dataGrids.search')"
      />
      <DxColumn
        :allow-filtering="true"
        :allow-header-filtering="false"
        :allow-sorting="false"
        :caption="$t('modules.forms.list.user')"
        :filter-operations="allowedOperations"
        data-field="userName"
      />
      <DxColumn
        :allow-filtering="true"
        :allow-header-filtering="false"
        :allow-sorting="false"
        :caption="$t('modules.forms.list.form')"
        :filter-operations="allowedOperations"
        data-field="formName"
      />
      <DxColumn
        :allow-filtering="true"
        :allow-header-filtering="false"
        :caption="$t('modules.forms.list.createdAt')"
        :filter-operations="allowedOperations"
        data-field="createdAt"
        data-type="date"
        format="yyyy-MM-dd HH:mm:ss"
      />
      <DxColumn type="buttons">
        <DxButton
          icon="edit"
          @click="edit"
        />
        <DxButton
          @click="deleteItem"
          hint="Usuń"
          icon="remove"
        />
      </DxColumn>
      <DxMasterDetail
        :enabled="true"
        template="master-detail"
      />
      <template #master-detail="{ data }">
        <div class="col-sm-6 col-md-6 col-lg-6 col-xl-5 col-xxl-4">
          {{ $t('modules.forms.form_history_table_head') }}:
          <li
            v-for="(detail, index) in data.data.details"
            :key="index"
            class="list-group-item d-flex justify-content-between align-items-start small"
          >
            <strong class="me-2">{{ detail.fieldName }}:</strong>
            <span class="text-muted">{{ detail.value }}</span>
          </li>
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {getStore} from './crud';
import {useI18n} from "vue-i18n";
import {useQuasar} from "quasar";
import { checkIfAdminOrBoss } from '@/utils/tools'
import {deleteData} from "@/components/content/_modules/forms/crud";
import {
  DxButton,
  DxColumn,
  DxColumnFixing, DxDataGrid,
  DxFilterRow,
  DxHeaderFilter, DxMasterDetail,
  DxPager, DxPaging,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import { loadMessages, locale } from 'devextreme/localization';
import messagesPl from '@/i18n/devextreme_pl.json';

export default defineComponent({
  name: 'ModulesFormsList',
  components: {
    DxMasterDetail,
    DxButton,
    DxPaging,
    DxDataGrid, DxColumn, DxHeaderFilter, DxFilterRow, DxPager, DxSearchPanel, DxColumnFixing
  },
  data() {
    return {
      moduleId: 1,
      pageTitle: this.$t('aside.menu.pages.modules.formsList'),
      allowedOperations: ['contains', '=', 'notcontains', '!='],
      remoteOperations: true,
      dataGridRef: 'ModuleFormListGrid',
      selectedItems: [],
      showCheckBoxesMode: 'always',
      store: getStore(),
      filterButton: false
    }
  },
  computed: {
    dataGrid() {
      const self: any = this
      return self.$refs[self.dataGridRef].instance
    }
  },
  setup() {
    const { t } = useI18n()

    return {
      quasar: useQuasar(),
      t
    }
  },
  methods: {
    edit(data: any) {
      this.$router.push(`/modules/forms/form/${data.row.data.hash}?userId=${data.row.data.userId}&date=${data.row.data.createdAt}`);
    },
    deleteItem(data){
      const self: any = this

      this.quasar.dialog({
        title: this.$t('modules.forms.list.deleteConfirmation'),
        message: `${this.$t('modules.forms.list.delete')} <br><b>${data.row.data.userName} -> ${data.row.data.formName} -> ${data.row.data.createdAt}</b><br><br><span style="color:red">${this.$t('modules.forms.list.deletePerm')}</span>`,
        html: true,
        cancel: true
      })
      .onOk(() => {
        deleteData(data.row.data.userId, data.row.data.createdAt).then(() => {
          self.refreshGrid()
        })
      })
    },
    resetFilters() {
      this.dataGrid.clearFilter();
    },
    checkFilters() {
      this.filterButton = this.dataGrid?.getCombinedFilter()?.length > 0;
    },
    refreshGrid() {
      if (this.dataGrid) {
        this.dataGrid.refresh();
      }
    },
  },
  mounted() {
    this.filterButton = false
    
    if(this.$i18n.locale === 'pl') {
      loadMessages(messagesPl);
      locale(this.$i18n.locale)
    }
  },
  beforeMount() {
    if (!checkIfAdminOrBoss()) {
      this.$router.push('/')
    }

    this.$emit('pageName', this.pageTitle)
    document.title = document.title + ' ' + this.$t('aside.menu.pages.modules.formsList')
    this.$emit('emitGetComponentId', this.moduleId)
  }
})
</script>